/* Sonnenuntergang-Berechnung (NOAA-Näherung) für die Golden-Hour-Anzeige */

export const sunsetMinutes = (lat, lng, date = new Date()) => {
  const rad = Math.PI / 180;
  const start = new Date(date.getFullYear(), 0, 0);
  const N = Math.floor((date - start) / 86400000);
  const lngHour = lng / 15;
  const t = N + (18 - lngHour) / 24;
  const M = 0.9856 * t - 3.289;
  let L = M + 1.916 * Math.sin(M * rad) + 0.02 * Math.sin(2 * M * rad) + 282.634;
  L = ((L % 360) + 360) % 360;
  let RA = Math.atan(0.91764 * Math.tan(L * rad)) / rad;
  RA = ((RA % 360) + 360) % 360;
  const Lquadrant = Math.floor(L / 90) * 90;
  const RAquadrant = Math.floor(RA / 90) * 90;
  RA = (RA + Lquadrant - RAquadrant) / 15;
  const sinDec = 0.39782 * Math.sin(L * rad);
  const cosDec = Math.cos(Math.asin(sinDec));
  const cosH = (Math.cos(90.833 * rad) - sinDec * Math.sin(lat * rad)) / (cosDec * Math.cos(lat * rad));
  if (cosH > 1 || cosH < -1) return null;
  const H = Math.acos(cosH) / rad / 15; // Sonnenuntergang
  const T = H + RA - 0.06571 * t - 6.622;
  let UT = T - lngHour;
  UT = ((UT % 24) + 24) % 24;
  const utcMidnight = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const localMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const offsetHours = (utcMidnight - localMidnight) / 3600000;
  let local = UT + offsetHours;
  local = ((local % 24) + 24) % 24;
  return Math.round(local * 60); // Minuten seit Mitternacht
};

const fmt = (mins) => {
  const h = Math.floor(mins / 60) % 24;
  const m = mins % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
};

/* Golden Hour = Stunde vor Sonnenuntergang. Ulm: 48.40° N, 9.99° O */
export const goldenHourToday = () => {
  const sunset = sunsetMinutes(48.4, 9.99);
  if (sunset === null) return null;
  return { start: fmt(sunset - 60), end: fmt(sunset) };
};
